import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconText2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V4.5H12.75V21H11.25V4.5H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconText2;
